export default function PHP_as() {
  return (
    <div>
      <h1>PHP_as</h1>
    </div>
  );
}
